import { createFileRoute, redirect } from "@tanstack/react-router";
import { UserRegisterForm } from "@/components/userRegisterForm";
import { resolvePostAuthDestination } from "@/lib/auth/postAuthDestination";
import { ensureAuthenticatedSession } from "@/lib/auth/sessionBootstrap";
import {
  getReferralCodeFromSearch,
  getStoredReferralCode,
  persistReferralCode,
} from "@/lib/referralCode";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/(unauth)/register")({
  component: RegisterPage,
  async beforeLoad({ context }) {
    if (context.session) {
      await ensureAuthenticatedSession(context.session.user, { staleOk: true });

      const destination = await resolvePostAuthDestination(context.session.user.id);
      throw redirect({ to: destination, replace: true });
    }
  },
});

function RegisterPage() {
  const [initialReferralCode] = useState(() => {
    if (typeof window === "undefined") return null;

    return getReferralCodeFromSearch(window.location.search) ??
      getStoredReferralCode();
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const referralFromSearch = getReferralCodeFromSearch(window.location.search);
    if (referralFromSearch) {
      persistReferralCode(referralFromSearch);
    }
  }, []);

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-slate-50 p-6 md:p-10">
      <div className="flex w-full max-w-md flex-col gap-6">
        <a href="#" className="flex items-center gap-2 self-center font-medium">
          <img
            src="/lockupBlack.svg"
            alt="Trainrr"
            className="h-6 [filter:brightness(0)_saturate(100%)_invert(20%)_sepia(98%)_saturate(3828%)_hue-rotate(219deg)_brightness(103%)_contrast(104%)]"
          />
        </a>
        <UserRegisterForm
          showReferralCode
          defaultReferralCode={initialReferralCode ?? undefined}
        />
        <div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4">
          By clicking continue, you agree to our{" "}
          <a className="hover:text-primary" href="https://trainrr.app/terms">
            Terms of Service
          </a>{" "}
          and{" "}
          <a className="hover:text-primary" href="https://trainrr.app/privacy">
            Privacy Policy
          </a>
          .
        </div>
      </div>
    </div>
  );
}
